
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
// import Alpine from 'alpinejs'
// import collapse from '@alpinejs/collapse'
import MicroModal from 'micromodal';
import tippy from 'tippy.js';

// function onNewEvent(event) {
//   switch (event.type) {
//     case "message":
//       // handle new message event
//       LiveChatWidget.call("maximize");
//       break;
//     default:
//       break;
//   }
// }

function init() {

  MicroModal.init({
    openClass: 'is-open', // [5]
    disableScroll: true, // [6]
    disableFocus: false, // [7]
    awaitOpenAnimation: true, // [8]
    awaitCloseAnimation: true // [9]
  });

  Swiper.use([Autoplay]); // Register the Autoplay module


  const swiperNotifications = new Swiper('.notification-slider', {
    direction: 'horizontal',
    effect: 'fade',
    fadeEffect: {
      crossFade: true
    },
    slidesPerView: 1,
    loop: true,
    speed: 500, // Controls smoothness (higher value = smoother)
    allowTouchMove: false, // Prevent user interruptions
    freeMode: true, // Allows continuous movement
    pauseOnMouseEnter: true, // Pause on hover
    autoplay: {
      delay: 5000,
      reverseDirection: true,
      disableOnInteraction: false,
    },

  });
  //
  // window.Alpine = Alpine;
  // Alpine.plugin(collapse)
  // Alpine.start();

  LiveChatWidget.init();
  // LiveChatWidget.on('new_event', onNewEvent)



  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

}

// Stop leave site prompt
window.addEventListener('beforeunload', function (event) {
  event.stopImmediatePropagation();
});

window.addEventListener("DOMContentLoaded", function () {
  tippy('[data-tippy-content]', {
    arrow: false,
    theme: 'light-border',
    allowHTML: true,
  });
  init(); //
  // window.Fancybox = Fancybox;

});
